export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/file.worker.e2aa593d.worker.js");
}
